import { ILink } from 'src/views/Links/types';
import { measureTextWidth } from './measureTextWidth';

export function calculateIDWidth(links: ILink[]) {
  return links.reduce((max, link) => {
    return Math.max(max, measureTextWidth(link.visibleId, { monospace: true }));
  }, 0);
}



// WEBPACK FOOTER //
// ./src/services/links/calculateIDWidth.ts